import { useState, useEffect } from "react";
import { API_BASE } from "../api/config";
import { useAuth } from "../context/AuthContext";
import { useLocation } from "react-router-dom";
import {
  Menu,
  LayoutDashboard,
  Database,
  ShoppingCart,
  CreditCard,
  FileText,
  Users,
  Building,
  Wallet,
  Layers,
  Package,
  Boxes,
  Table,
  ClipboardList,
  LogOut,
  Utensils,
   Banknote, // ✅ Added for cash payments
  Coins,    // ✅ Optional: for coin/cash icons
  Receipt,  // ✅ Optional: for receipts
} from "lucide-react";
import MenuItem from "./MenuItem";

function Layout({ children }) {
  const { username, logout, loginType, branch } = useAuth();
  const location = useLocation();

  const [companyName, setCompanyName] = useState("");
  const [openDropdown, setOpenDropdown] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false); // for mobile toggle

  const toggleDropdown = (menu) =>
    setOpenDropdown(openDropdown === menu ? null : menu);

  // Fetch company name
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await fetch(
          `${API_BASE}?key=dzital_key&pswd=Hibujji@123&table=company&transac=get`
        );
        const result = await response.json();
        if (result.status === "ok" && result.data.length > 0) {
          setCompanyName(result.data[0].company_name);
        }
      } catch (err) {
        console.error("Error fetching company:", err);
      }
    };
    fetchCompany();
  }, []);

  // Close dropdowns when navigating
  useEffect(() => {
    setOpenDropdown(null);
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex flex-col h-screen bg-gradient-to-b from-blue-900 via-blue-950 to-black text-white">
      {/* 🔹 Header */}
      <header className="bg-gradient-to-r from-blue-800 via-blue-900 to-black text-white shadow-lg sticky top-0 z-50">
        <div className="flex items-center justify-between px-6 py-3">
          {/* Company name + Mobile toggle */}
          <div className="flex items-center gap-4">
            <span className="font-bold text-lg tracking-wide text-white">
              {companyName || "Loading..."}
            </span>
            <button
              className="md:hidden p-2 rounded hover:bg-blue-800"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <Menu size={22} />
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6 text-sm">
            <MenuItem
              icon={<LayoutDashboard size={18} />}
              text="Dashboard"
              to="/dashboard"
            />

            {/* Master Data Dropdown */}
            {[1, 2, 3].includes(loginType) && (
              <div className="relative">
                <button
                  onClick={() => toggleDropdown("master")}
                  className="flex items-center gap-2 hover:text-yellow-400"
                >
                  <Database size={18} /> Master Data
                  <span>{openDropdown === "master" ? "▲" : "▼"}</span>
                </button>

                {openDropdown === "master" && (
                  <div className="absolute left-0 top-full bg-blue-950 text-white rounded shadow-lg py-2 mt-1 z-50 min-w-[200px] border border-blue-800">
                    {loginType === 1 && (
                      <>
                        <MenuItem
                          icon={<Building size={16} />}
                          text="Company"
                          to="/company"
                        />
                        
                      </>
                    )}

                    {[1, 2].includes(loginType) && (
                      <>
                       
                      </>
                    )}
					<MenuItem
                          icon={<Building size={16} />}
                          text="Branches"
                          to="/branches"
                        />
					 <MenuItem
                          icon={<Wallet size={16} />}
                          text="PaymentModes"
                          to="/payment-modes"
                        />
                        <MenuItem
                          icon={<ClipboardList size={16} />}
                          text="Accounts"
                          to="/accounts"
                        />

                    {[1, 2].includes(loginType) && (
                      <MenuItem
                        icon={<Users size={16} />}
                        text="Logins"
                        to="/logins"
                      />
                    )}

                    <MenuItem
                      icon={<Layers size={16} />}
                      text="Groups"
                      to="/groups"
                    />
                    <MenuItem
                      icon={<Package size={16} />}
                      text="Items"
                      to="/items"
                    />
                    <MenuItem
                      icon={<Table size={16} />}
                      text="Tables"
                      to="/tables"
                    />
                  </div>
                )}
              </div>
            )}

            {/* Other Menus */}
            <MenuItem
              icon={<Utensils size={18} />}
              text="Orders"
              to="/kots-by-kitchen"
            />
            <MenuItem
              icon={<CreditCard size={18} />}
              text="Checkout"
              to="/checkout"
            />
			<MenuItem
              icon={<Banknote size={18} />}
              text="Payments"
              to="/payments"
            />
			 {/* Reports Dropdown */}
            <div className="relative">
              <button
                onClick={() => toggleDropdown("reports")}
                className="flex items-center gap-2 hover:text-yellow-400"
              >
                <FileText size={18} /> Reports
                <span>{openDropdown === "reports" ? "▲" : "▼"}</span>
              </button>

              {openDropdown === "reports" && (
                <div className="absolute left-0 top-full bg-blue-950 text-white rounded shadow-lg py-2 mt-1 z-50 min-w-[200px] border border-blue-800">
                  <MenuItem icon={<ClipboardList size={16} />} text="KOT" to="/kots" />
                  <MenuItem icon={<ClipboardList size={16} />} text="Sales" to="/sales" />
                </div>
              )}
            </div>
          </nav>

          {/* User Info */}
          <div className="hidden md:flex items-center gap-4 text-sm">
            <span className="opacity-90">
              {username} ({branch})
            </span>
            <button
              onClick={logout}
              className="flex items-center gap-2 bg-red-600 hover:bg-red-700 px-3 py-1 rounded text-sm"
            >
              <LogOut size={16} /> Logout
            </button>
          </div>
        </div>

        {/* 🔹 Mobile Navigation */}
        {menuOpen && (
          <div className="md:hidden bg-blue-950 text-white flex flex-col space-y-1 p-3 border-t border-blue-800">
            <MenuItem
              icon={<LayoutDashboard size={18} />}
              text="Dashboard"
              to="/dashboard"
            />

            {[1, 2, 3].includes(loginType) && (
              <>
                <button
                  onClick={() => toggleDropdown("master")}
                  className="flex items-center justify-between py-2"
                >
                  <span className="flex items-center gap-2">
                    <Database size={18} /> Master Data
                  </span>
                  <span>{openDropdown === "master" ? "▲" : "▼"}</span>
                </button>
                {openDropdown === "master" && (
                  <div className="pl-4 space-y-1">
                    {loginType === 1 && (
                      <>
                        <MenuItem icon={<Building size={16} />} text="Company" to="/company" />
                      </>
                    )}
                    {[1, 2].includes(loginType) && (
                      <>
                        
                      </>
                    )}
					
                        <MenuItem icon={<Building size={16} />} text="Branches" to="/branches" />
					<MenuItem icon={<Wallet size={16} />} text="PaymentModes" to="/payment-modes" />
                        <MenuItem icon={<ClipboardList size={16} />} text="Accounts" to="/accounts" />
                    {[1, 2].includes(loginType) && (
                      <MenuItem icon={<Users size={16} />} text="Logins" to="/logins" />
                    )}
                    <MenuItem icon={<Layers size={16} />} text="Groups" to="/groups" />
                    <MenuItem icon={<Package size={16} />} text="Items" to="/items" />
                    <MenuItem icon={<Table size={16} />} text="Tables" to="/tables" />
                  </div>
                )}
              </>
            )}

            <MenuItem icon={<Utensils size={18} />} text="Orders" to="/kots-by-kitchen" />
            <MenuItem icon={<CreditCard size={18} />} text="Checkout" to="/checkout" />
			<MenuItem icon={<Banknote size={18} />} text="Payments" to="/Payments" />
			
			<button
              onClick={() => toggleDropdown("reports")}
              className="flex items-center justify-between py-2"
            >
              <span className="flex items-center gap-2">
                <FileText size={18} /> Reports
              </span>
              <span>{openDropdown === "reports" ? "▲" : "▼"}</span>
            </button>
            {openDropdown === "reports" && (
              <div className="pl-4 space-y-1">
                <MenuItem icon={<ClipboardList size={16} />} text="KOT" to="/kots" />
                <MenuItem icon={<ClipboardList size={16} />} text="Sales" to="/sales" />
              </div>
            )}

            <button
              onClick={logout}
              className="flex items-center gap-2 bg-red-600 hover:bg-red-700 px-3 py-2 rounded mt-2"
            >
              <LogOut size={18} /> Logout
            </button>
          </div>
        )}
      </header>

      {/* 🔹 Main Content */}
      <main className="flex-1 overflow-y-auto p-6 bg-blue-900/60 backdrop-blur-sm rounded-t-lg">
        {children}
      </main>
    </div>
  );
}

export default Layout;
